import React, { useEffect, useState } from 'react';
import { BookOpen, ChevronRight } from 'lucide-react';
import mapi from './api';
import { MobileShell, MobileHeader, C } from './MobileShell';
import { useMobile } from './MobileContext';

const FILTER = [
  { k: 'alle', label: 'Alle' },
  { k: 'schueler', label: 'Meine Schüler:innen' },
  { k: 'kurse', label: 'Meine Kurse' },
];

function zeit(eintrag) {
  const uhr = [eintrag.start, eintrag.end].filter(Boolean).join('–');
  return [eintrag.weekday, uhr].filter(Boolean).join(', ');
}

export default function MobileLogbook() {
  const { teacherId } = useMobile();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('alle');
  const [query, setQuery] = useState('');

  const load = () => {
    const params = teacherId ? { teacher_id: teacherId } : {};
    mapi.get('/app/logbook', { params })
      .then((r) => setItems(r.data?.items || []))
      .catch(() => setItems([]));
  };
  useEffect(load, [teacherId]);

  const needle = query.trim().toLowerCase();
  const shown = items.filter((eintrag) => {
    if (filter !== 'alle' && eintrag.kind !== filter) return false;
    if (!needle) return true;
    return (eintrag.title || '').toLowerCase().includes(needle);
  });

  return (
    <MobileShell>
      <MobileHeader title="ShareSpace" backTo="/m/files" onRefresh={load} />
      <div className="flex-1 overflow-y-auto px-4 py-3 pb-10">
        <div className="mb-3 flex items-start gap-3 px-1">
          <BookOpen className="mt-0.5 h-6 w-6 shrink-0" style={{ color: C.red }} />
          <div>
            <h2 className="text-lg font-bold" style={{ color: C.text }} data-testid="mobile-logbuch-title">
              Logbuch
            </h2>
            <p className="text-xs" style={{ color: C.dim }}>
              Notizen, Aufgaben und Unterrichtsfortschritte pro Schüler:in oder Kurs.
            </p>
          </div>
        </div>
        <div className="mb-3 flex items-center rounded-lg px-3 py-2"
             style={{ background: C.card, border: `1px solid ${C.border}` }}>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Schüler:in / Kurs suchen…"
            data-testid="mobile-logbuch-search"
            className="flex-1 bg-transparent text-sm outline-none"
            style={{ color: C.text }}
          />
        </div>
        <div className="mb-3 flex gap-2 overflow-x-auto">
          {FILTER.map(({ k, label }) => {
            const on = filter === k;
            return (
              <button
                key={k}
                type="button"
                data-testid={`mobile-logbuch-filter-${k}`}
                className="shrink-0 rounded-full px-3 py-1.5 text-xs font-semibold"
                style={{
                  background: on ? C.red : C.card,
                  color: on ? '#fff' : C.text,
                  border: `1px solid ${on ? C.red : C.border}`,
                }}
                onClick={() => setFilter(k)}
              >
                {label}
              </button>
            );
          })}
        </div>
        {!shown.length && (
          <p className="mt-10 text-center text-sm" style={{ color: C.dim }} data-testid="mobile-logbuch-empty">
            Kein Unterricht zugeordnet.
          </p>
        )}
        {shown.map((eintrag) => (
          <div
            key={eintrag.id}
            data-testid={`mobile-logbuch-${eintrag.id}`}
            className="mb-3 flex items-center gap-3 rounded-xl px-3 py-3"
            style={{ background: C.card, border: `1px solid ${C.border}` }}
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl"
                  style={{ background: C.rose }}>
              <BookOpen className="h-5 w-5" style={{ color: C.red }} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-semibold" style={{ color: C.text }}>
                {eintrag.title}
              </span>
              <span className="block text-[11px]" style={{ color: C.dim }}>
                {eintrag.form}
                {eintrag.participants != null ? ` · ${eintrag.participants} Teilnehmende` : ''}
              </span>
              {zeit(eintrag) && (
                <span className="block text-[11px]" style={{ color: C.dim }}>{zeit(eintrag)}</span>
              )}
            </span>
            <span className="shrink-0 text-[11px]" style={{ color: C.dim }}>
              {eintrag.entries} Einträge
            </span>
            <ChevronRight className="h-4 w-4 shrink-0" style={{ color: C.dim }} />
          </div>
        ))}
      </div>
    </MobileShell>
  );
}
